<fui-podium>
    <div class="status-podium">
        <div class="status-podium-header">
            <div>{{(serverStatusModel.status ? 'wbo.bi.server-status.' + serverStatusModel.status.status :
                'wbo.bi.server-status.INITIALISING') | translate}}
            </div>
        </div>
        <div class="status-podium-main">
            <fui-icon
                *ngIf="serverStatusModel.status && (serverStatusModel.status.status === status.FAILED || serverStatusModel.status.status === status.UNAVAILABLE)"
                [height]="48" [icon]="'error'" [width]="48"></fui-icon>
            <ng-container *ngIf="serverStatusModel.status && serverStatusModel.status.status === status.INITIALISING">
                <fui-ellipsis-loader class="status-podium-main-spinner"></fui-ellipsis-loader>
                <div class="status-podium-main-progressbar">
                    <div class="status-podium-main-progressbar-inner"
                         [style.width.%]="serverStatusModel.status ? serverStatusModel.status.percentComplete : 0"></div>
                </div>
            </ng-container>
        </div>

    </div>
</fui-podium>
